import React from "react";
import { Calendar, ExternalLink, Phone } from "lucide-react";

const HeroSection = () => {
  const scrollToContact = () => {
    const element = document.getElementById("contact-form");
    if (element) element.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      role="banner"
      className="relative min-h-[100svh] flex items-center justify-center overflow-hidden bg-[#1C3A27]"
      aria-labelledby="hero-title"
    >
      {/* Image Hero premium (crépuscule, guirlandes) */}
      <picture>
        <source media="(max-width: 640px)" srcSet="/images/hero/hero-nuit-mobile.webp" type="image/webp" />
        <source media="(max-width: 640px)" srcSet="/images/hero/hero-nuit-mobile.jpg" />
        <source srcSet="/images/hero/hero-nuit.webp" type="image/webp" />
        <img
          src="/images/hero/hero-nuit.jpg"
          width="2200"
          height="1650"
          fetchPriority="high"
          decoding="async"
          alt="Terrasse et jardin du gîte Cœurs de Normands au crépuscule, illuminés par des guirlandes lumineuses"
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
      </picture>

      {/* Dégradé haut (lisibilité navigation) */}
      <div className="absolute inset-x-0 top-0 h-40 bg-gradient-to-b from-black/50 to-transparent pointer-events-none" />
      {/* Vignette centrale localisée derrière le texte */}
      <div
        className="absolute inset-0 pointer-events-none"
        style={{
          background:
            "radial-gradient(ellipse 85% 55% at 50% 48%, rgba(0,0,0,0.55) 0%, rgba(0,0,0,0.25) 45%, rgba(0,0,0,0) 75%)",
        }}
      />

      {/* Contenu */}
      <div className="relative z-10 text-center px-4 sm:px-6 lg:px-8 max-w-5xl mx-auto">
        <div className="animate-fade-in-up">
          <h1
            id="hero-title"
            className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-3 md:mb-5 leading-[1.1] [text-shadow:_0_2px_18px_rgba(0,0,0,0.45)]"
          >
            Gîte Cœurs de Normands
          </h1>

          <p className="text-lg sm:text-xl md:text-2xl text-white/90 mb-8 md:mb-10 max-w-2xl mx-auto leading-relaxed [text-shadow:_0_1px_12px_rgba(0,0,0,0.5)]">
            Un havre de paix en Suisse Normande
          </p>

          {/* CTA principaux */}
          <div className="flex flex-col sm:flex-row gap-3 md:gap-4 justify-center items-center">
            <button
              onClick={scrollToContact}
              className="btn-primary text-base md:text-lg px-6 md:px-8 py-3 md:py-4 w-full sm:w-auto min-h-[48px] shadow-xl focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black/40"
              aria-label="Voir les disponibilités - aller au formulaire de demande de séjour"
            >
              <Calendar size={20} className="flex-shrink-0" />
              <span className="ml-2">Voir les disponibilités</span>
            </button>

            <a
              href="tel:+33664104815"
              className="btn-secondary text-base md:text-lg px-6 md:px-8 py-3 md:py-4 w-full sm:w-auto min-h-[48px] bg-black/30 backdrop-blur-sm text-white border-white/70 hover:bg-white hover:text-[#1C3A27] focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-black/40"
              aria-label="Appeler directement - 06 64 10 48 15"
            >
              <Phone size={20} className="flex-shrink-0" />
              <span className="ml-2">Appeler maintenant</span>
            </a>
          </div>

          {/* Plateformes (secondaire, discret) */}
          <div className="flex flex-row gap-3 justify-center items-center mt-4">
            <a
              href="https://www.airbnb.fr/rooms/1124426465764074190"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-white/90 hover:text-white underline underline-offset-4 decoration-white/40 hover:decoration-white transition-colors"
              aria-label="Réserver sur Airbnb - ouverture dans un nouvel onglet"
            >
              <ExternalLink size={16} /> Airbnb
            </a>
            <span className="text-white/40">•</span>
            <a
              href="https://www.booking.com/hotel/fr/gite-au-coeur-de-la-suisse-normande.fr.html"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-1.5 text-sm text-white/90 hover:text-white underline underline-offset-4 decoration-white/40 hover:decoration-white transition-colors"
              aria-label="Réserver sur Booking - ouverture dans un nouvel onglet"
            >
              <ExternalLink size={16} /> Booking
            </a>
          </div>
        </div>
      </div>

      {/* Indicateur de scroll */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 hidden md:block z-10">
        <div className="animate-bounce">
          <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center">
            <div className="w-1 h-3 bg-white/70 rounded-full mt-2"></div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
